import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SITE_NAME } from '@freelancer/config';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private readonly title = inject(Title);
  private readonly siteName = inject(SITE_NAME);

  private baseTitle: string;
  private prefix = '';

  /**
   * Set the base title and update the title.
   * @param title - The title to set
   */
  setTitle(title: string, includeSiteName?: boolean): void {
    this.baseTitle = includeSiteName ? `${title} | ${this.siteName}` : title;
    this.updateTitle();
  }
  /**
   * Set the title with a prefix and an optional title. If base title is not set (which only happens if a title
   * hasn't been configured for the route AND the component hasn't loaded (i.e. the page hasn't been loaded yet)),
   * the base title will be set to the site name - this avoids the situation where the base title is undefined for a
   * moment until either the title strategy can set the base title, or the page is loaded.
   *
   * @param prefix - The prefix to add to the title
   * @param optional title - The title to set
   */
  setPrefix(prefix: string, title?: string): void {
    if (title) {
      this.baseTitle = title;
    }
    if (!this.baseTitle) {
      this.baseTitle = this.siteName;
    }
    this.prefix = prefix;
    this.updateTitle();
  }

  /**
   * Update the title with the base title and prefix if one exists.
   */
  private updateTitle(): void {
    if (this.prefix !== '') {
      this.title.setTitle(`${this.prefix} ${this.baseTitle}`);
    } else {
      this.title.setTitle(this.baseTitle);
    }
  }
}
